
// TODO: 現状、仕様予定なし
export default class GameStartResponse {

  constructor(
    private data: any
  ) { }

  get result(): any {
    return this.data
  }
}
